import * as AccountingReportService from '@/services/apis/accountingReport'
const state = {
}

const actions = {
    async getAccountingRepositDeposit({ }, params) {
        try {
            const res = await AccountingReportService.getAccountingRepositDeposit(params)
            return res.data
        } catch (err) {
            if(err.message){ throw JSON.parse(err.message) }
        }
    },
    async getAccountingRepositWithdraw({ }, params) {
        try {
            const res = await AccountingReportService.getAccountingRepositWithdraw(params)
            return res.data
        } catch (err) {
            if(err.message){ throw JSON.parse(err.message) }
        }
    },
    async getAccountingFirstDeposit({ }, params) {
        try {
            const res = await AccountingReportService.getAccountingFirstDeposit(params)
            return res.data
        } catch (err) {
            if(err.message){ throw JSON.parse(err.message) }
        }
    },
    async getAccountingNoDeposit({ }, params) {
        try {
            const res = await AccountingReportService.getAccountingNoDeposit(params)
            return res.data
        } catch (err) {
            if(err.message){ throw JSON.parse(err.message) }
        }
    },
    async getAccountingDepositPromotion({ }, params) {
        try {
            const res = await AccountingReportService.getAccountingDepositPromotion(params)
            return res.data
        } catch (err) {
            if(err.message){ throw JSON.parse(err.message) }
        }
    },
}


export default {
    state,
    actions,
}
